import { Fragment, useMemo } from 'react';
import arrowLeft from '~/assets/icons/arrow_left.svg';
import info from '~/assets/icons/info_2.svg';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { ScrollContainer } from '~/components/ui/ScrollContainer';
import { SectionHeading } from '~/components/ui/SectionHeading';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { usePlayerLevel } from '../../hooks';
import { setActiveStage, useLayoutDispatch } from '../../redux';
import { JobDefinitions } from '../../views/Jobs/Jobs.model';
import { JobsStage } from '../JobsPanel/JobsPanel.model';
import { LevelCard } from '../LevelCard';
import {
	StyledAboutContainer,
	StyledAboutGrid,
	StyledButtonContent,
	StyledContainer,
	StyledDescContainer,
	StyledImageBg,
	StyledStageItem,
	StyledStagesContainer,
	StyledTopContainer,
} from './About.styled';

const About = () => {
	const dispatch = useLayoutDispatch();
	const jobId = useObservable(rage.jobs.getOpenedJobId());
	const jobConfig = useMemo(
		() => (jobId ? JobDefinitions[jobId] : null),
		[jobId],
	);
	const { playerLevel, playerMaxLevel } = usePlayerLevel();

	if (!jobConfig) {
		return null;
	}

	return (
		<StyledContainer>
			<StyledTopContainer>
				<StyledDescContainer>
					<Text>
						{jobConfig.descriptionSummary
							.trim()
							.split('\n')
							.map((str, index) => (
								<Fragment key={`panelDesc#${index}`}>
									{str}
									<br />
								</Fragment>
							))}
					</Text>
				</StyledDescContainer>
				<StyledStagesContainer>
					<StyledStageItem>
						<StyledImageBg />
						<div className="number">
							<Text>1</Text>
						</div>
						<Text>{jobConfig.descriptionDetailed?.[0]?.text}</Text>
					</StyledStageItem>
					<StyledStageItem>
						<StyledImageBg />
						<div className="number">
							<Text>2</Text>
						</div>
						<Text>{jobConfig.descriptionDetailed?.[1]?.text}</Text>
					</StyledStageItem>
					<StyledStageItem>
						<StyledImageBg />
						<div className="number">
							<Text>3</Text>
						</div>
						<Text>{jobConfig.descriptionDetailed?.[2]?.text}</Text>
					</StyledStageItem>
				</StyledStagesContainer>
			</StyledTopContainer>
			<StyledAboutContainer>
				<SectionHeading text="Доступные уровни" icon={info} />
				<ScrollContainer width={560} height={320} showMask>
					<StyledAboutGrid>
						{Array.from({ length: playerMaxLevel }, (_, index) => (
							<LevelCard
								key={index}
								level={index + 1}
								text={jobConfig.levelsDetailed?.[index] ?? ''}
								active={index + 1 === playerLevel}
								disabled={index + 1 < playerLevel}
							/>
						))}
					</StyledAboutGrid>
				</ScrollContainer>
			</StyledAboutContainer>
			<Button
				color={ButtonColors.Default}
				height={ButtonHeight.Height60}
				style={{ fontSize: 16 }}
				onClick={() => dispatch(setActiveStage(JobsStage.MAIN))}
			>
				<StyledButtonContent>
					<img src={arrowLeft} />
					<Text>Вернуться назад</Text>
				</StyledButtonContent>
			</Button>
		</StyledContainer>
	);
};

export { About };
